import React, { useState, useEffect } from 'react';
import { MessageType } from 'models/BaseModel';
import { Code } from 'helpers/CalendarImports';

interface ToastMessageProps {
  Messages: MessageType;
  Error: string | null;
}

const ToastMessage: React.FC<ToastMessageProps> = ({ 
  Messages,
  Error 
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (Messages.messages.length > 0) {
      setIsVisible(true);
      
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 3000);

      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [Messages.messages]);

  //if(Error) console.log(Error);
  
  if (Messages.messages.length === 0 || !isVisible) return null; 

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setIsVisible(false); 
  };

  let headerTitle = '';
  let messageSymbol = '';
  const frameClass = Messages.type == Code.Message.type.INFO ? 'ok' : '';
  if(Messages.type == Code.Message.type.EMPTY_FIELDS){
    headerTitle = 'Required Fields Missing:';
    messageSymbol = '• ';
  }

  return (
    <div className={`toastbox ${frameClass}`} id="errorMessage">
      <span className="close" onClick={handleClick}>⨯</span>
      {headerTitle && <strong>{headerTitle}</strong>}
      {Messages.messages.map((message, index) => (
        <span className='db' key={index}>{messageSymbol}{message} <br/></span>
      ))}
    </div>
  );
};

interface ConfirmMessageProps {
  Messages: MessageType;
  onConfirm: () => void; 
  onRefuse: () => void;
}

const ConfirmMessage: React.FC<ConfirmMessageProps> = ({ Messages, onConfirm, onRefuse }) => {
  
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
      if (Messages.messages.length > 0) {
        setIsVisible(true);
      } else {
        setIsVisible(false); 
      }
    }, [Messages.messages]); 

  if (Messages.messages.length === 0 || !isVisible) return null;

  const handleClickYes = (e: React.FormEvent) => {
    e.preventDefault();
    setIsVisible(false);
    onConfirm(); 
  };
  
  const handleClickClose = () => {
    onRefuse();
    setIsVisible(false);
  };

  if (Messages.messages.length === 0) return null; 

  return (
    <div className="toastbox" id="errorMessage">
      <span className="close" onClick={handleClickClose}>⨯</span> 
      {Messages.messages.map((message, index) => (
        <span key={index}>{message}</span>
      ))}
      <div className="options">
        <span onClick={handleClickYes} accessKey="y">Yes</span> 
        <span onClick={handleClickClose} accessKey="n">No</span>
      </div>
    </div>
  );
};

export const Messages = {
  Toast: ToastMessage,
  Confirm: ConfirmMessage,
}
